import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrequentUseDto } from '../../models/frequent-use.dto';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FrequentUseService {

 private readonly path = '/frequentUse';
    
    constructor(private http: HttpClient) {}
    
    getAll(): Observable<FrequentUseDto[]> {
      return this.http.get<FrequentUseDto[]>(`${environment.apiBaseUrl}${this.path}`);
    }
}
